import type { Frame } from '../store/types';
import { getDisplayHtml } from '../store/commands';

export function frameToHtmlDoc(f: Frame, byId: Map<string, Frame> = new Map()): string {
  const body = getDisplayHtml(f, byId);
  return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>${escapeHtml(f.title)}</title>
</head>
<body>
${body}
</body>
</html>
`;
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]!));
}
